export function validateDates(initialDateString, finalDateString, showSnack, edit = false) {
  const [initialYear, intialMonth, initialDay] = initialDateString
    .split("-")
    .map(Number);
  const initialDate = new Date(initialYear, intialMonth - 1, initialDay); // Month is 0-indexed
  initialDate.setHours(0, 0, 0, 0);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (edit === false) {
    const initialDateIsFuture = initialDate >= today;
    if (initialDateIsFuture === false) {
      showSnack("La fecha inicial no puede ser anterior a hoy");
      return false;
    }
  }

  const [finalYear, finalMonth, finalDay] = finalDateString
    .split("-")
    .map(Number);
  const finalDate = new Date(finalYear, finalMonth - 1, finalDay); // Month is 0-indexed
  finalDate.setHours(0, 0, 0, 0);

  if (finalDate < today || finalDate < initialDate) {
    showSnack("La fecha final debe ser mayor que hoy y que la fecha inicial");
    return false;
  }

  return true;
}

export function ValidateFirstStep(mainDataCreate) {
  let hasErrors = false; // Cambiamos el nombre para mayor claridad

  // Verificamos cada campo si está vacío o no
  const validationChecks = {
    photo_profile: mainDataCreate.photo_profile.length === 0, // Comprobar si el array está vacío
    gallery: mainDataCreate.gallery.length === 0, // Comprobar si el array está vacío
    name: mainDataCreate.name.trim() === "",
    name_business: mainDataCreate.name_business.trim() === "",
    information: mainDataCreate.information.trim() === "",
    min_investment: mainDataCreate.min_investment.trim() === "",
    esti_profitability: mainDataCreate.esti_profitability.trim() === "",
    objective: mainDataCreate.objective.trim() === "",
    loans: mainDataCreate.loans.trim() === "",
    initial_date: mainDataCreate.initial_date.trim() === "",
    final_date: mainDataCreate.final_date.trim() === "",
  };
  for (let key in validationChecks) {
    if (validationChecks[key]) {
      hasErrors = true; // Si hay algún campo que no pasa la validación
      break;
    }
  }

  return !hasErrors; // Retornamos verdadero si no hay errores
}

export function ValidateSecondStep(mainDataCreate) {
  let hasErrors = false; // Cambiamos el nombre para mayor claridad

  // Verificamos cada campo si está vacío o no
  const validationChecks = {
    min_marketing: mainDataCreate.min_marketing.trim() === "",
    max_marketing: mainDataCreate.max_marketing.trim() === "",
    min_construction: mainDataCreate.min_construction.trim() === "",
    max_construction: mainDataCreate.max_construction.trim() === "",
    min_offered_capital: mainDataCreate.min_offered_capital.trim() === "",
    max_offered_capital: mainDataCreate.max_offered_capital.trim() === "",
    min_stake: mainDataCreate.min_stake.trim() === "",
    max_stake: mainDataCreate.max_stake.trim() === "",
    min_return_investment: mainDataCreate.min_return_investment.trim() === "",
    max_return_investment: mainDataCreate.max_return_investment.trim() === "",
  };
  for (let key in validationChecks) {
    if (validationChecks[key]) {
      hasErrors = true; // Si hay algún campo que no pasa la validación
      break;
    }
  }

  return !hasErrors; // Retornamos verdadero si no hay errores
}

export function validateMinMaxIsValid(minValue, minField, maxValue, maxField, showSnack) {
  if (minValue === "") {
    showSnack(`Llene el campo ${minField}`);
    return false;
  }

  if (maxValue === "") {
    showSnack(`Llene el campo ${maxField}`);
    return false;
  }

  if (parseFloat(minValue) >= parseFloat(maxValue)) {
    showSnack(`${maxField} debe ser mayor que ${minField}`);
    return false;
  }

  return true;
}

export function editFormIsNotEmpty(mainDataEdit) {
  let hasErrors = false;

  const validationChecks = {
    // photo_profile: mainDataEdit.photo_profile.length !== 0,
    // photo_profile_edit: mainDataEdit.photo_profile.length === 0,
    name: mainDataEdit.name.trim() === "",
    name_business: mainDataEdit.name_business.trim() === "",
    information: mainDataEdit.information.trim() === "",
    objective: mainDataEdit.objective.trim() === "",
    loans: mainDataEdit.loans.trim() === "",
    esti_profitability: mainDataEdit.esti_profitability.trim() === "",
    min_investment: mainDataEdit.min_investment.trim() === "",
    initial_date: mainDataEdit.initial_date.trim() === "",
    final_date: mainDataEdit.final_date.trim() === "",
    // gallery: mainDataEdit.gallery.length !== 0,
    // gallery_edit: mainDataEdit.gallery_edit.length === 0,
    min_offered_capital: mainDataEdit.min_offered_capital.trim() === "",
    max_offered_capital: mainDataEdit.max_offered_capital.trim() === "",
    min_return_investment: mainDataEdit.min_return_investment.trim() === "",
    max_return_investment: mainDataEdit.max_return_investment.trim() === "",
    min_stake: mainDataEdit.min_stake.trim() === "",
    max_stake: mainDataEdit.max_stake.trim() === "",
    min_marketing: mainDataEdit.min_marketing.trim() === "",
    max_marketing: mainDataEdit.max_marketing.trim() === "",
    min_construction: mainDataEdit.min_construction.trim() === "",
    max_construction: mainDataEdit.max_construction.trim() === "",
    warranty_inmobiliaria: mainDataEdit.warranty_inmobiliaria.trim() === "",
    warranty_economica: mainDataEdit.warranty_economica.trim() === "",
    invested: mainDataEdit.invested.trim() === "",
    expenses_marketing: mainDataEdit.expenses_marketing.trim() === "",
    expenses_construction: mainDataEdit.expenses_construction.trim() === "",
    expenses_vehicles: mainDataEdit.expenses_vehicles.trim() === "",
    expenses_wages: mainDataEdit.expenses_wages.trim() === "",

  };
  for (let key in validationChecks) {
    if (validationChecks[key]) {
      hasErrors = true;
      break;
    }
  }

  return !hasErrors;
}
